import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// FIXME: из публичного SDK не должно быть обращений к @beefco/core, да и createLibrary тут не особо в тему
import { extractComponentDSL } from '@beefco/core';
import { Mapper, Root } from "../internals/components";
import { ModuleTreeObserver } from "../hmr";
/**
 * Функция возвращает библиотеку компонентов
 * для использования ts props parser нужно в options передать флаг useTsPropParser
 * документация лежит в репе beefco: /packages/lib-props-parser/README.md
 */
export var createLibrary = function createLibrary(componentsDict, childModule, options) {
  var source = _objectSpread(_objectSpread({}, componentsDict), {}, {
    Mapper: Mapper,
    Root: Root
  });
  if (import.meta.webpackHot) {
    ModuleTreeObserver.create().subscribe(childModule);
  }
  if (process.env.NODE_ENV === 'production') {
    return {
      source: source,
      dsl: null
    };
  }
  return {
    source: source,
    dsl: {
      components: Object.keys(source).map(function (componentId) {
        return {
          fields: extractComponentDSL(_objectSpread({
            // Значение по умолчанию, без него - краш
            propTypes: {}
          }, source[componentId])),
          id: componentId
        };
      })
    },
    rootPath: options !== null && options !== void 0 && options.useTsPropParser ? childModule.id : undefined
  };
};